import { types } from "../../types/types";

const initialState = {
  empresa: {},
  error: "",
  validadaAFIP: false,
  loading: false,
  busqueda: "",
  cargada: false,
  empresaABM: null,
  seguimientoEmpresa: []
};
export const empresasReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.empresaLimpiar:
      return {
        empresa: {},
        error: "",
        validadaAFIP: false,
        loading: false,
        busqueda: "",
        cargada: false,
        empresaABM: null
      };
    case types.empresaTraerAFIPStart:
      return {
        ...state,
        loading: true,
        error: null,
        validadaAFIP: false,
        cargada: false,
        busqueda: "AFIP",
      };
    case types.empresaTraerAFIPSuccess:
      return {
        ...state,
        loading: false,
        empresa: action.payload,
        cargada: true,
        validadaAFIP: true,
        busqueda: "AFIP",
        empresaABM: action.payload
      };
    case types.empresaTraerAFIPError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        empresa: {},
        cargada: false,
        busqueda: "AFIP",
      };
    case types.empresaTraerPorCUITStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
        busqueda: "CUIT",
      };
    case types.empresaTraerPorCUITSuccess:
      return {
        ...state,
        loading: false,
        empresa: action.payload,
        cargada: true,
        busqueda: "CUIT",
        empresaABM: action.payload
      };
    case types.empresaTraerPorCUITError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        empresa: {},
        cargada: false,
        busqueda: "CUIT",
      };
    case types.empresaUpdated:
      return {
        ...state,
        empresa: action.payload,
      };
    case types.seleccionarEmpresaABM:
      return {
        ...state,
        empresaABM: action.payload
      }
    case types.desSeleccionarEmpresaABM:
      return {
        ...state,
        empresaABM: null
      }
    case types.updateStoreEmpresaABM:
      return {
        ...state,
        empresaABM: action.payload,
      };
    case types.actualizarSeguimientoEmpresasSuccess:
      return {
        ...state,
        seguimientoEmpresa: action.payload
      }
    case types.traerSeguimientoEmpresaSuccess:
      return {
        ...state,
        seguimientoEmpresa: action.payload
      }
    case types.limpiarSeguimientoEmpresaSuccess:
      return {
        ...state,
        seguimientoEmpresa: []
      }
    default:
      return state;
  }
};
